export default __webpack_public_path__ + "static/media/masskeko.3e5dac03.gif";